import React, { useContext, useEffect, useRef, useState, useCallback, useMemo } from 'react'
import { MediaContext, NavigationContext, UIContext } from './context'
import useTouchNavigation from './hooks/useTouchNavigation';
import ImageWithShimmer from '../common/ImageWithShimmer';
import { IMAGE_COMPRESSOR } from '../../utils/imageCompressor';
import { LeftArrow, RightArrow } from '../common/config';
import VideoItem from './VideoItem';
import View360 from '../View360/View360';
import ImageCategoryDropdown from './ImageCategoryDropdown';
import ProductCategoryDropdown from './ProductCategoryDropdown';
import ZoomControls from './ZoomControls';
import useImageZoom from './hooks/useImageZoom';
import useMediaDataAndTabs from './hooks/useMediaDataAndTabs';
import { useDispatch, useSelector } from 'react-redux';
import { 
  setIs360IndexRedux,
  setIs360IntIndexRedux,
  updateInterior360Url,
  setInteriorHotspotIndex 
} from '../../Redux/Reducers/View360Reducer/View360ActionController';
import { checkIsV3 } from '../../utils/getAppVersion';
import Interior360 from '../Interior360/Interior360';
import Tooltip from '../common/Tooltip';
import UspComponentT1 from './usp-hotspot/usp-component-t1';


//viewer component selected 360, video OR image contet
const MainViewer = ({enterpriseId, isExpanded,setIsExpanded, template, handleFullScreen, isFullScreen = false, dynamicTabImage, isFirstSixExt=true,infoFormDataT2=null, handleMobileExitFullScreen, handleMobileFullScreen, isMobileFullScreen = false, isMobileFullScreenFromQuery = false, isHeroImageMode = false }) => {
const [selectedImageTab, setSelectedImageTab] = useState(dynamicTabImage?.[0]?.label ?? 'Exterior');
const { teamId } = useMediaDataAndTabs();
  // Split context consumption
  const { selectedTab, aspectRatio, } = useContext(MediaContext);
  const { carouselItems, handleLeft, handleRight, selectedIndex, handleSelectThumbnail, skipAnimation } = useContext(NavigationContext);
  const { showOverlays, setShowOverlays, isSingleProduct, handleRecordEngagement, sessionId, handleUpdateTimeSpentBy360, handleStartEngagementTime, zoomFeatureUsed, setZoomFeatureUsed, showCall, setShowCall, showEmail, setShowEmail, showChat, setShowChat, conversationConfig,mediaId,autoCall, isEmbeddedContext } = useContext(UIContext);
  const [shouldLoadImage, setShouldLoadImage] = useState(false);
  const hasFirstItem360 = carouselItems?.[0]?.type === "360";

  // gives image, 360 and video as products (in case of image give multiple images) [360, video, image, image, image, image, image]
  const availableProducts = carouselItems && carouselItems.length > 0 ? carouselItems?.map(item => item.type) : [];

  const [viewerState, setViewerState] = useState({
    is360: false,
    is360Index: 0,
    is360Int: false,
    is360IntIndex: 1
  });
  // map for imagerefs
  const imageRefs = useRef({});
  const mainViewerRef = useRef(null);
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const hideExpand = queryParams.get('isConsole') === 'true';

  const isListing = queryParams.get("isListing");
  const iframeSource = queryParams.get('source');
  const isDemo = queryParams.get('demo');
  // Create zoom state for the currently selected image
  const {
    zoomLevel,
    handleZoomIn,
    handleZoomOut,
    handleMouseDown: handleMouseDownImage,
    handleTouchStart: handleTouchStartImage,
    handleTouchMove: handleTouchMoveImage,
    resetZoom,
    imageStyle
  } = useImageZoom(imageRefs.current[selectedIndex]);
  const isV3 = checkIsV3();
  const { interiorHotspotIndex, toggleHotspotView } = useSelector(state => state.view360Reducer);
  const THOMBOR_URL = "https://media.spyneai.com/unsafe/filters:format(webp)/"

  useEffect(() => {
    const has360 = carouselItems?.some(item => item?.type === "360");
    const has360Int = carouselItems?.some(item => item?.type === "360Int");
    const index360 = carouselItems?.findIndex(item => item?.type === "360");
    const index360Int = carouselItems?.findIndex(item => item?.type === "360Int");
    setViewerState(prev => ({
      ...prev,
      is360: has360,
      is360Index: index360,
      is360Int: has360Int,
      is360IntIndex: index360Int
    }));
    if (has360) {
      dispatch(setIs360IndexRedux(index360));
    }
    if (has360Int) {
      dispatch(setIs360IntIndexRedux(index360Int));
    }
  }, [carouselItems]);
  // Add a useEffect to track when zoom is used via gestures
  useEffect(() => {
    // If zoom level changes from 0 to something else, it means zoom was used
    if (selectedTab === 'image' && zoomLevel > 0) {
      const currentItem = carouselItems[selectedIndex] || {};
      const imageId = currentItem?.data?.image_id;
      
      if (imageId && !zoomFeatureUsed.includes(imageId)) {
        setZoomFeatureUsed(prev => [...prev, imageId]);
      }
    }
  }, [zoomLevel, selectedTab, selectedIndex, carouselItems, zoomFeatureUsed, setZoomFeatureUsed]);

  const { handleTouchStart, handleTouchEnd, handleTouchMove } = useTouchNavigation(handleLeft, handleRight, carouselItems, selectedIndex);

  const containerheight = aspectRatio === "16/9" ? containerRef.current?.clientWidth * (9 / 16) : containerRef.current?.clientWidth * (3 / 4);
  const heightFull = containerheight + 60 > window.innerHeight ? true : isHeroImageMode ? true : false;
  let firstImageIndex = carouselItems?.findIndex((item) => item?.type === "image");
  let lastImageIndex = carouselItems?.findLastIndex((item) => item?.type === "image");
  let firstExteriorIndex = carouselItems?.findIndex((item) => item?.type === "image" && item?.category === "exterior");
  let firstInteriorIndex = carouselItems?.findIndex((item) => item?.type === "image" && item?.category === "interior");
  let firstAdditionalIndex = carouselItems?.findIndex((item) => item?.type === "image" && item?.category === "additional");

  useEffect(() => {
    resetZoom();
  }, [selectedIndex]);

  // Initialize refs for all images //map
  useEffect(() => {
    carouselItems?.forEach((item, index) => {
      if (item.type === "image" && !imageRefs.current[index]) {
        imageRefs.current[index] = React.createRef();
      }
    });
  }, [carouselItems]);

  useEffect(() => {
    if (selectedTab === "image") {
      let category = carouselItems?.[selectedIndex]?.category
      let tab = dynamicTabImage?.find((tab) => tab?.label?.toLowerCase() === category?.toLowerCase())
      setSelectedImageTab(tab?.label)
    }
  }, [selectedTab, selectedIndex, carouselItems, dynamicTabImage]);

  // Add a separate touch cancel handler to ensure overlays show up when touch is cancelled
  const handleTouchCancel = useCallback((e) => {
    // Always show overlays when touch is cancelled (e.g., user scrolls or gesture is interrupted)
    setShowOverlays(true);
  }, [setShowOverlays]);

  // Add a timeout ref to ensure overlays show up even if touchend/mouseup is missed
  const overlayTimeoutRef = useRef(null);

  // Enhanced mouse down handler with timeout fallback
  const handleMouseDownWithTimeout = useCallback((e) => {
    // Clear any existing timeout
    if (overlayTimeoutRef.current) {
      clearTimeout(overlayTimeoutRef.current);
    }

    // Check for buttons and interactive elements that should not trigger overlay hiding
    if (e.target.closest('button') || 
        e.target.closest('.MuiSwitch-root') || 
        e.target.closest('.MuiSwitch-switchBase') ||
        e.target.closest('[role="button"]') ||
        e.target.closest('input[type="checkbox"]') ||
        e.target.closest('.pointer-events-auto') ||
        e.target.closest('[data-mobile-toggle-handler]') ||
        e.target.closest('[data-mobile-toggle-switch]')) {
      return;
    }
    
    setShowOverlays(false);
    
    // Set a fallback timeout to show overlays if touchend/mouseup doesn't fire
    overlayTimeoutRef.current = setTimeout(() => {
      setShowOverlays(true);
    }, 3000); // Show overlays after 3 seconds if no touchend/mouseup
  }, [setShowOverlays]);

  // Enhanced mouse up handler that clears timeout
  const handleMouseUpWithTimeout = useCallback((e) => {
    // Clear the fallback timeout
    if (overlayTimeoutRef.current) {
      clearTimeout(overlayTimeoutRef.current);
      overlayTimeoutRef.current = null;
    }

    // Check for buttons and interactive elements that should not trigger overlay showing
    if (e.target.closest('button') || 
        e.target.closest('.MuiSwitch-root') || 
        e.target.closest('.MuiSwitch-switchBase') ||
        e.target.closest('[role="button"]') ||
        e.target.closest('input[type="checkbox"]') ||
        e.target.closest('.pointer-events-auto') ||
        e.target.closest('[data-mobile-toggle-handler]') ||
        e.target.closest('[data-mobile-toggle-switch]')) {
      return;
    }
    
    setShowOverlays(true);
  }, [setShowOverlays]);

  useEffect(() => {
    if (mainViewerRef?.current) {
      const element = mainViewerRef.current;
      
      // Mouse events
      element.addEventListener('mousedown', handleMouseDownWithTimeout);
      element.addEventListener('mouseup', handleMouseUpWithTimeout);
      
      // Touch events with passive option for better performance on mobile
      element.addEventListener('touchstart', handleMouseDownWithTimeout, { passive: true });
      element.addEventListener('touchend', handleMouseUpWithTimeout, { passive: true });
      element.addEventListener('touchcancel', handleTouchCancel, { passive: true });
    }

    return () => {
      if (mainViewerRef?.current) {
        const element = mainViewerRef.current;
        
        // Clean up mouse events
        element.removeEventListener('mousedown', handleMouseDownWithTimeout);
        element.removeEventListener('mouseup', handleMouseUpWithTimeout);
        
        // Clean up touch events
        element.removeEventListener('touchstart', handleMouseDownWithTimeout);
        element.removeEventListener('touchend', handleMouseUpWithTimeout);
        element.removeEventListener('touchcancel', handleTouchCancel);
      }
      
      // Clean up any pending timeout
      if (overlayTimeoutRef.current) {
        clearTimeout(overlayTimeoutRef.current);
      }
    }
  }, [mainViewerRef, handleMouseDownWithTimeout, handleMouseUpWithTimeout, handleTouchCancel]);

  const [is360Loading, setIs360Loading] = useState(hasFirstItem360 || false);

  const handle360LoadComplete = () => {
    if (is360Loading) {
      setIs360Loading(false);
    }
  };
  // Determine if image should load
  const getShouldLoadImage = () => {
    // Load if either:
    // 1. 360 view has finished loading
    // 2. This is the currently selected image
    return !is360Loading || selectedTab === "image"
  };
  useEffect(() => {
    let shouldLoad = getShouldLoadImage();
    setShouldLoadImage(shouldLoad);
  }, [is360Loading, selectedTab]);


  // Update interior360Url in Redux when carousel items change
  useEffect(() => {
    if (isV3) {
      const interior360Item = carouselItems?.find(item => item?.type === "360Int");
      if (interior360Item?.data) {
        // Ensure we're passing the correct data structure
        const interiorData = {
          type: '360',
          data: {
            ...interior360Item.data,
            // Ensure we have the correct URL format
            output_image_hres_url: interior360Item.data.output_image_hres_url || interior360Item.data.url,
            input_image_hres_url: interior360Item.data.input_image_hres_url,
            url: interior360Item.data.url
          }
        };
        dispatch(updateInterior360Url(interiorData));
      }
    }
  }, [carouselItems, isV3, dispatch]);

  const handleHotspotIndexChange = useCallback((index) => {
    dispatch(setInteriorHotspotIndex(index));
  }, [dispatch]);

  // Memoize the handlers
  const memoizedUpdateTimeSpent = useCallback(handleUpdateTimeSpentBy360, []);
  const memoizedHotspotIndexChange = useCallback(handleHotspotIndexChange, []);

  const interior360State = useMemo(() => {
    const item360Int = carouselItems?.find(item => item?.type === "360Int");
    if (!item360Int) return null;

    const state = {
      interior360Url: {
        type: '360',
        data: {
          ...item360Int?.data,
          output_image_hres_url: item360Int?.data?.output_image_hres_url || item360Int?.data?.url,
          input_image_hres_url: item360Int?.data?.input_image_hres_url,
          url: item360Int?.data?.url
        }
      }
    };

    const isMobileView = template === "mobile";
    const hotspotDataInterior = item360Int?.data?.hotspots;
    const selectedTemplate = template;

    return {
      state,
      isMobileView,
      interiorTimeSpent: memoizedUpdateTimeSpent,
      onHotspotIndexChange: memoizedHotspotIndexChange,
      currentHotspotIndex: interiorHotspotIndex,
      isCommonIframeT1T2: true,
      hotspotDataInterior,
      selectedTemplate
    };
  }, [carouselItems, template, memoizedUpdateTimeSpent, memoizedHotspotIndexChange, interiorHotspotIndex]);

  
  // Memoize hotspot data
  const hotspotDataInterior = useMemo(() => {
    const item360Int = carouselItems?.find(item => item?.type === "360Int");
    return item360Int?.data?.hotspots || null;
  }, [carouselItems]);


  // Constants for fullscreen button
  const FULLSCREEN_BUTTON_STYLES = {
    base: "absolute -right-[3px] bottom-[2px] md:bottom-[7px] z-10 w-12 h-12",
    hidden: "hidden"
  };

  const FULLSCREEN_ICONS = {
    enter: "https://spyne-static.s3.us-east-1.amazonaws.com/console/white-square.svg",
    exit: "https://spyne-static.s3.us-east-1.amazonaws.com/EXIT_FULLSCREEN.svg"
  };

  // Helper function to determine if fullscreen button should be visible
  const shouldShowFullscreenButton = (item) => {
    // Always show if overlays are visible
    if (showOverlays) return true;
    
    // Hide for 360 items when overlays are hidden
    if (item.type === "360") return false;
    
    return true;
  };

  // Helper function to determine which fullscreen button to show
  const getFullscreenButtonConfig = (item) => {
    const isVisible = shouldShowFullscreenButton(item);
    
    if (!isVisible) return null;

    // Mobile fullscreen exit button
    if (isMobileFullScreenFromQuery) {
      return {
        onClick: (e) => e.isTrusted && handleMobileExitFullScreen(),
        icon: FULLSCREEN_ICONS.exit,
        alt: "Exit Full Screen"
      };
    }

    // Mobile fullscreen enter button
    if (template === "mobile") {
      return {
        onClick: (e) => e.isTrusted && handleMobileFullScreen(),
        icon: FULLSCREEN_ICONS.enter,
        alt: "Full Screen"
      };
    }

    // Desktop fullscreen button (only when not in fullscreen)
    if (!isFullScreen && !isMobileFullScreenFromQuery) {
      return {
        onClick: (e) => e.isTrusted && handleFullScreen(),
        icon: FULLSCREEN_ICONS.enter,
        alt: "Full Screen"
      };
    }

    return null;
  };

  // Render fullscreen button component
  const renderFullscreenButton = (item) => {
    const config = getFullscreenButtonConfig(item);
    
    if (!config) return null;

    const buttonClasses = `${FULLSCREEN_BUTTON_STYLES.base} ${!shouldShowFullscreenButton(item) ? FULLSCREEN_BUTTON_STYLES.hidden : ""}`;

    return (
      <button 
        onClick={config.onClick} 
        className={buttonClasses}
      >
        <img 
          src={THOMBOR_URL + config.icon} 
          alt={config.alt} 
          className="w-full h-full" 
        />
      </button>
    );
  };

  return (
    <div className={`h-full relative rounded-lg overflow-hidden`} ref={containerRef}>
        <div className={`${((!showOverlays && selectedTab === "360") || (template === "mobile" && (selectedTab === "video" || selectedTab === "360")) || (template === "mobile" && isV3 && toggleHotspotView)) ? "hidden" : ""} absolute inset-0 w-full flex justify-between items-center px-4 pointer-events-none`}
          style={{
            zIndex: 12,
            height: (template === "t2") ? containerheight : "100%",
          }}
        >
          {(isV3 && !isExpanded) && availableProducts.length > 1 && <div className={`pointer-events-auto ${(template === "mobile" && (selectedTab === "image") && (selectedIndex === firstImageIndex)) ? "hidden" : ""}`}>
            <LeftArrow
              handleLeft={() => {
                handleLeft(carouselItems?.length, selectedIndex);
              }}
              className="cursor-pointer w-7 h-7"
            />
          </div>}
          {(isV3 && !isExpanded) && availableProducts.length > 1 && <div className={`pointer-events-auto ${(template === "mobile" && (selectedTab === "image") && (selectedIndex === lastImageIndex)) ? "hidden" : ""}`}>
            <RightArrow
              handleRight={() => {
                handleRight(carouselItems?.length, selectedIndex);
              }}
              className="cursor-pointer w-7 h-7"
            />
          </div>}
        </div>

      <div className={`absolute left-0 w-full z-10 
           ${template === "t1" ? "!h-full !max-h-full mx-auto" : template === "mobile" ? heightFull ? "h-full" : "top-1/2 -translate-y-1/2 w-full my-auto" : "h-full mx-auto sm:mx-0 sm:h-auto sm:w-full my-auto "}
                 flex items-center justify-center overflow-hidden
                 `}
        style={{
          height: containerheight,
        }}>
        
        {/* {template === "mobile" && <div className={`pointer-events-auto z-10 absolute top-2 left-2 border-none`}>
          <ProductCategoryDropdown />
        </div>} */}
        {/* {selectedTab === "image" && template === "mobile" && (dynamicTabImage?.length > 1) && !isListing && (
            <ImageCategoryDropdown
              options={dynamicTabImage}
              selectedTab={selectedImageTab}
              onSelect={(option) => {
                setSelectedImageTab(option.label);
                handleSelectThumbnail(
                  option.label === "Exterior"
                    ? firstExteriorIndex
                    : option.label === "Interior"
                    ? firstInteriorIndex
                    : firstAdditionalIndex,
                'image'
              );
            }}
          />
        )} */}
        <div className='' onClick={() => {
          // Get current item data if this is an image and we have a selected index
          const currentItem = carouselItems[selectedIndex] || {};
          if (selectedTab === 'image') {
            handleRecordEngagement("image", currentItem?.data);
          }
        }} style={{
          height: "100%",
          aspectRatio: aspectRatio,
          position: 'relative'
        }}>
          {selectedTab === 'image' && !isListing && <ZoomControls
              zoomLevel={zoomLevel}
              onZoomIn={() => {
                // Get current image data
                const currentItem = carouselItems[selectedIndex] || {};
                const imageId = currentItem?.data?.image_id;
                
                if (imageId && !zoomFeatureUsed.includes(imageId)) {
                  setZoomFeatureUsed(prev => [...prev, imageId]);
                }
                
                handleZoomIn();
              }}
              onZoomOut={() => {
                // Get current image data
                const currentItem = carouselItems[selectedIndex] || {};
                const imageId = currentItem?.data?.image_id;
                
                if (imageId && !zoomFeatureUsed.includes(imageId)) {
                  setZoomFeatureUsed(prev => [...prev, imageId]);
                }
                
                handleZoomOut();
              }}
          />}
        </div>
        {/* USP Components for T1 template positioned at middle right and left */}
        {template === "t1" && (
          <>
            {/* Middle Right USP Component */}
            {carouselItems?.[selectedIndex]?.type === "360" || carouselItems?.[selectedIndex]?.type === "360Int" ? (
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20 pointer-events-auto max-w-[400px]" style={{
              }}>
                <UspComponentT1 handleSelectThumbnail={handleSelectThumbnail} />
              </div>
            ) : null}
          </>
        )}
        {/* carous)}el container */}
        <div
          className={`flex absolute w-full h-full ${skipAnimation ? "transition-none" : "transition-transform duration-500 ease-in-out"}`}
          style={{
            transform: `translateX(${-selectedIndex * 100}%)`,
            width: `100%`,
            left: '0',
          }}
          ref={mainViewerRef}
          onTouchStart={(selectedTab === "image" && zoomLevel === 0) ? handleTouchStart : null}
          onTouchMove={(selectedTab === "image" && zoomLevel === 0) ? handleTouchMove : null}
          onTouchEnd={(selectedTab === "image" && zoomLevel === 0) ? handleTouchEnd : null}
        >

        {/* USP Components for T1 template positioned at middle right and left */}
        {template === "t1" && (
          <>
            {/* Middle Right USP Component */}
            {carouselItems?.[selectedIndex]?.type === "360" || carouselItems?.[selectedIndex]?.type === "360Int" ? (
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20 pointer-events-auto max-w-[400px]" style={{
                zIndex: 100
              }}>
                <UspComponentT1 handleSelectThumbnail={handleSelectThumbnail} />
              </div>
            ) : null}
          </>
        )}

          {
            carouselItems?.map((item, index) => {
              return (
                <div key={index} className={`w-full h-full transition-all duration-500 ease-in-out flex-shrink-0 rounded-xl
            ${template === "mobile" && "flex justify-center !rounded-none"}
            `}>
                <div
                    className={`overflow-hidden object-cover rounded-xl cursor-pointer relative ${template === "t1" ? "!h-full !max-h-full mx-auto" : template === "mobile" ? heightFull ? "h-full" : "w-full my-auto" : "h-full mx-auto md:mx-0 md:h-auto md:w-full my-auto "}
                flex items-center justify-center overflow-hidden ${template === "mobile" && "!rounded-none"}
                `}
                  style={{
                      aspectRatio: aspectRatio
                  }}
                  // onDoubleClick={handleFullScreen}
                >
                    {(item.type === "360") && (
                      <View360
                        preloadedData={item?.data}
                        selectedIndex={selectedIndex}
                        onLoadComplete={is360Loading ? handle360LoadComplete : null}
                        handleRecordEngagement={handleRecordEngagement}
                        handleUpdateTimeSpentBy360={handleUpdateTimeSpentBy360}
                        handleStartEngagementTime={handleStartEngagementTime}
                        isCommonIframeT1T2={true}
                        selectedTemplate={template}
                        selectedTab={selectedTab}
                        enterpriseId={enterpriseId}
                        isEmbeddedContext={isEmbeddedContext} 
                        isMobileFullScreen={isMobileFullScreenFromQuery}                         
                      />
                    )}
                    {(item.type === "360Int") && (
                      (
                        <Interior360
                          state={interior360State.state}
                          isMobileView={interior360State.isMobileView}
                          interiorTimeSpent={interior360State.interiorTimeSpent}
                          onHotspotIndexChange={interior360State.memoizedHotspotIndexChange}
                          currentHotspotIndex={interior360State.currentHotspotIndex}
                          isCommonIframeT1T2={interior360State.isCommonIframeT1T2}
                          hotspotDataInterior={interior360State.hotspotDataInterior}
                          selectedTemplate={interior360State.selectedTemplate}
                          isMobileFullScreen={isMobileFullScreenFromQuery}
                        />
                      )
                    )}
                    {
                      item.type === "video" && (
                        <div className='w-full h-full' onClick={() => handleRecordEngagement("video")}>
                      <VideoItem item={item} template={template} />
                    </div>
                      )
                    }
                    {
                      (item.type === "image") && (
                        <>
                        <ImageWithShimmer
                          src={IMAGE_COMPRESSOR({ url: item?.data?.output_image_hres_url })}
                          alt={item?.data?.alt || 'image'}
                          className={`w-full h-full object-contain object-center rounded-xl ${template === "mobile" && "!rounded-none"}`}
                      imageWithShimmerRef={imageRefs.current[index]}
                      handleMouseDown={handleMouseDownImage}
                      handleTouchStart={handleTouchStartImage}
                      handleTouchMove={handleTouchMoveImage}
                      imageStyle={imageStyle}
                      enableZoom={selectedIndex === index}
                          shouldStartLoading={shouldLoadImage ? 'eager' : 'lazy'}
                          isShimmerItem={item?.data?.isShimmer || item?.isShimmer}
                          onClick={() => {
                            if (selectedIndex === index) {
                              handleRecordEngagement("image", item?.data);
                            }
                          }}
                        />
                        {((item.category === "exterior"  && viewerState.is360 && template !=="mobile")) && (
                          <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 z-20">
                            <button 
                              className="text-white rounded-lg transition-all duration-300"
                              onClick={() => {
                                handleSelectThumbnail(viewerState.is360Index,"three_sixty")
                              }}
                            >
                              <div className='flex p-[0px_10px] sm:p-[6px_16px] items-center gap-2 bg-[#000000]/20 backdrop-blur-[3px] p-2.5 rounded-3xl'>
                                <span className="whitespace-nowrap text-[#FFF] text-sm font-medium leading-5">View in</span>
                                <img src="https://spyne-static.s3.us-east-1.amazonaws.com/three_sixty_icon.svg" alt="Full Screen" className="w-full h-full" />
                              </div>
                            </button>
                          </div>
                        )}
                        {((item.category === "interior"  && viewerState.is360Int && template !=="mobile")) && (
                          <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 z-20">
                            <button 
                              className="text-white rounded-lg transition-all duration-300"
                              onClick={() => {
                                handleSelectThumbnail(viewerState.is360IntIndex,"360Int")
                              }}
                            >
                              <div className='flex p-[0px_10px] sm:p-[6px_16px] items-center gap-2 bg-[#000000]/20 backdrop-blur-[3px] p-2.5 rounded-3xl'>
                                <span className="whitespace-nowrap text-[#FFF] text-sm font-medium leading-5">View in</span>
                                <img src="https://spyne-static.s3.us-east-1.amazonaws.com/three_sixty_icon.svg" alt="Full Screen" className="w-full h-full" />
                              </div>
                            </button>
                          </div>
                        )}
                        </>
                      )
                    }
                  {/* Full screen button */}
                  {template !== "mobile" && !hideExpand && renderFullscreenButton(item)} 
                    {/* https://spyne-static.s3.us-east-1.amazonaws.com/EXIT_FULLSCREEN.svg */}
                  {/* {
                  <button onClick={handleShareModal} className={`${(!showOverlays && item.type === "360") ? "hidden": ""} absolute right-[1%] top-[1%] z-10 w-10 h-10`}>
                    <svg
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="white"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))'
                      }}
                    >
                      <path d="M13.125 18C12.3958 18 11.776 17.7375 11.2656 17.2125C10.7552 16.6875 10.5 16.05 10.5 15.3C10.5 15.21 10.5219 15 10.5656 14.67L4.41875 10.98C4.18542 11.205 3.91563 11.3814 3.60938 11.5092C3.30312 11.637 2.975 11.7006 2.625 11.7C1.89583 11.7 1.27604 11.4375 0.765625 10.9125C0.255208 10.3875 0 9.75 0 9C0 8.25 0.255208 7.6125 0.765625 7.0875C1.27604 6.5625 1.89583 6.3 2.625 6.3C2.975 6.3 3.30312 6.3639 3.60938 6.4917C3.91563 6.6195 4.18542 6.7956 4.41875 7.02L10.5656 3.33C10.5365 3.225 10.5184 3.1239 10.5114 3.0267C10.5044 2.9295 10.5006 2.8206 10.5 2.7C10.5 1.95 10.7552 1.3125 11.2656 0.7875C11.776 0.2625 12.3958 0 13.125 0C13.8542 0 14.474 0.2625 14.9844 0.7875C15.4948 1.3125 15.75 1.95 15.75 2.7C15.75 3.45 15.4948 4.0875 14.9844 4.6125C14.474 5.1375 13.8542 5.4 13.125 5.4C12.775 5.4 12.4469 5.3361 12.1406 5.2083C11.8344 5.0805 11.5646 4.9044 11.3312 4.68L5.18437 8.37C5.21354 8.475 5.23192 8.5764 5.2395 8.6742C5.24708 8.772 5.25058 8.8806 5.25 9C5.24942 9.1194 5.24592 9.2283 5.2395 9.3267C5.23308 9.4251 5.21471 9.5262 5.18437 9.63L11.3312 13.32C11.5646 13.095 11.8344 12.9189 12.1406 12.7917C12.4469 12.6645 12.775 12.6006 13.125 12.6C13.8542 12.6 14.474 12.8625 14.9844 13.3875C15.4948 13.9125 15.75 14.55 15.75 15.3C15.75 16.05 15.4948 16.6875 14.9844 17.2125C14.474 17.7375 13.8542 18 13.125 18Z" fill="white" />
                    </svg>
                  </button>
                } */}


                  </div>
                  
                </div>
              )
            })
          }


        </div>
      </div>
    </div >
  )
}

export default MainViewer